import EnrollmentAcknowledgement from "../../../enrollmentAcknowledgement/EnrollmentAcknowledgement";
import { OpenEnrollment } from "../../../../../../types/openEnrollment.types";
import { Plan } from "../../../../../../types/plan.types";
import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { PlanAcknowledgementProps } from "../../../../../../types/components/enrollmentProps.types";
import { EnrollmentSchema } from "../../../../../../types/enrollment.types";
import { AuthContext, ThemeContext } from "../../../../../../contexts";
import { Paper, Grid, Button } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";

const IntercityPlanAcknowledgement = ({
	openEnrollments,
	enrollments,
	planName,
	showEnrollButton
}: PlanAcknowledgementProps): JSX.Element => {
	const [openEnrollment, setOpenEnrollment] = useState<
		OpenEnrollment & {
			plan: Plan;
		}
	>();
	const { theme } = useContext(ThemeContext);
	const [enrollment, setEnrollment] = useState<EnrollmentSchema>();
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	// console.log("akncow enrollments", enrollments);

	const findPlanOpenEnrollment = useCallback(() => {
		for (let openEnrollmentIdx = 0; openEnrollmentIdx < openEnrollments.length; openEnrollmentIdx++) {
			const _openEnrollment = openEnrollments[openEnrollmentIdx].open_enrollment;
			if (_openEnrollment.plan.plan_name === planName) {
				setOpenEnrollment(Object.assign({}, _openEnrollment));
				break;
			}
		}
	}, [openEnrollments, planName]);

	const findPlanEnrollment = useCallback(() => {
		if (!member) {
			return;
		}
		for (let enrollmentIdx = 0; enrollmentIdx < enrollments.length; enrollmentIdx++) {
			const _enrollment = enrollments[enrollmentIdx];
			if (
				_enrollment.member_SSN === member.SSN &&
				_enrollment.insured_SSN === member.SSN &&
				_enrollment.plan.plan_name === planName
			) {
				setEnrollment(Object.assign({}, _enrollment));
				break;
			}
		}
	}, [enrollments, member, planName]);

	const handleEnrollAgainButtonClick = useCallback(() => {
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
	}, [history, urlSearchParams]);

	useEffect(() => {
		findPlanOpenEnrollment();
		findPlanEnrollment();
	}, [findPlanEnrollment, findPlanOpenEnrollment]);

	if (!enrollment) return <></>;

	return (
		<div className="paper-form-container">
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{openEnrollment && enrollment ? (
					<EnrollmentAcknowledgement
						idCardAccessPointRequired={true}
						dependentChangePointRequired={true}
						carrierPhoneNo={"214 520 2565"}
						carrierWebsite={"intercityinvestments.com"}
						planDocument={openEnrollment.plan.document}
						planName={openEnrollment.plan.plan_name}
						addDependentLink={"/home/add-family-member"}
						planCode={openEnrollment.plan.plan_code}
						removeDependentLink={""}
						status={enrollment.enrollment_status}
					/>
				) : null}
				<div className="theme-plan-section-margin" />
				{showEnrollButton === false ? null : ["SUBMITTED", "WAIVED"].includes(enrollment?.enrollment_status) ? (
					<Grid container>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
							<Button
								style={{
									backgroundColor: theme.button.background_color,
									color: theme.button.color,
									width: "100%"
								}}
								onClick={handleEnrollAgainButtonClick}
							>
								Enroll again
							</Button>
						</Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
					</Grid>
				) : null}
			</Paper>
		</div>
	);
};

export default IntercityPlanAcknowledgement;
